module.exports = __webpack_public_path__ + "img/L46-croatia.160422fb.png";